import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'underscore';

import "./calendar.less";

interface P {
    today?: moment.Moment;
    epoch?: moment.Moment;
    value?: moment.Moment;
    onChange?: (date: moment.Moment) => void;
}

interface S {
    cursor: moment.Moment;
}

export default class Calendar extends React.Component<P, S> {

    private today_: moment.Moment;

    constructor( props: P, context: any ) {
        super( props, context );

        this.today_ = moment();
        this.state = { cursor: moment( this.props.value || this.today ) };
    }

    private get today(): moment.Moment {
        return this.props.today || this.today_;
    }

    private get epoch(): moment.Moment {
        return this.props.epoch || this.today;
    }

    private prev() {
        this.setState({ cursor : this.state.cursor.subtract( 1, 'months' ) });
    }

    private next() {
        this.setState({ cursor : this.state.cursor.add( 1, 'months' ) });
    }

    private pick( date: moment.Moment ) {
        if ( this.props.onChange && !date.isBefore(this.epoch, 'day') )
            this.props.onChange( date );
    }

    render() {
        const dayNames = [ 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun' ];

        let weeks: moment.Moment[][] = [];
        let w: moment.Moment[] = [];
        let it: moment.Moment;
        for ( let k = -6; ; k++ ) {
            it = moment( this.state.cursor ).date( k );

            w.push( it );
            if ( !it.day() ) {
                weeks.push( w );
                w = [];

                if ( it.isAfter(this.state.cursor, 'month') )
                    break;
            }
        }
        weeks.shift();
        if ( 7 <= it.date() )
            weeks.pop();

        let dayDivs = dayNames.map((name) =>
            <div key={ name }>{ name }</div>
        );
        let weekDivs = weeks.map(days =>
            <div className="week" key={ _.first(days).format('~YYYY-MM-DD') }>
              { days.map(day => {
                    if ( !day.isSame(this.state.cursor, 'month') )
                        return (
                            <div key={ day.format('@YYYY-MM-DD') }></div>
                        );

                    var className = ( day.isSame(this.props.value, 'day') ?
                                      'selected' : day.isBefore(this.epoch, 'day') ?
                                      'past' :
                                      'upcoming' );
                    if ( day.isSame(this.today, 'day') )
                        className += ' today';

                    return (
                        <div className={ className } key={ day.format('@YYYY-MM-DD') }>
                          <div onClick={ () => this.pick(day) }>{ day.date() }</div>
                        </div>
                    );
                }) }
            </div>
        );

        let prev = this.state.cursor.isAfter( this.epoch, 'month' ) ?
                   (<div className="prev fa fa-chevron-left" onClick={ () => this.prev() }></div>) :
                   (<div className="disabled prev fa fa-chevron-left"></div>);
        return (
            <div className="calendar component">
              <link rel="stylesheet"
                    href="//maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css" />

              <div className="mo">
                { prev }
                <div className="stamp">
                  { this.state.cursor.format( 'MMMM YYYY' ) }
                </div>
                <div className="next fa fa-chevron-right" onClick={ () => this.next() }></div>
              </div>
              <div className="days">
                { dayDivs }
              </div>

              { weekDivs }
            </div>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/widgets/Calendar.tsx
 **/